<template>
    <div class="upload-example">
		<div class="button-wrapper">
            <label v-if="label.length > 0" class="add-files_form-label" for="file">{{ label }}</label>
            <v-file-input
				loader-height="5"
				:loading="loadFile"
				:clearable="false"
				v-model="file"
                ref="file"
                id="file"
                @change="loadImage($event)"
                hide-details
                outlined
                placeholder="Файл jpg, jpeg, png"
                accept="image/png, image/jpeg"
            />

		</div>

		<cropper
			v-show="getCroppFlag"
			class="upload-example-cropper mt-2"
			@ready="loadFile = false"
			ref="cropper"
			:src="image.src"
			:stencil-component="$options.components.CircleStencil"
			:canvas="{
				height: 200,
				width: 200
			}"
		/>
		<v-btn v-show="getCroppFlag && !loadFile && file" :loading="loadingBtn" class="mt-2" @click="uploadImage" block color="primary">Обрезать и сохранить</v-btn>
		<v-btn v-show="getCroppFlag && !loadFile" class="mt-2" @click="cancel" block color="warning">Отменить</v-btn>
	</div>
</template>

<script>
import { CircleStencil, Cropper } from 'vue-advanced-cropper';
import {mapGetters, mapMutations} from 'vuex'
import 'vue-advanced-cropper/dist/style.css';


function getMimeType(file, fallback = null) {
	const byteArray = (new Uint8Array(file)).subarray(0, 4);
    let header = '';
    for (let i = 0; i < byteArray.length; i++) {
       header += byteArray[i].toString(16);
    }
	switch (header) {
        case "89504e47":
            return "image/png";
        case "47494638":
            return "image/gif";
        case "ffd8ffe0":
        case "ffd8ffe1":
        case "ffd8ffe2":
        case "ffd8ffe3":
        case "ffd8ffe8":
            return "image/jpeg";
        default:
            return fallback;
    }
}

export default {
    props: {
        label: { type: String, default: () => '' },
        url: { type: String, default: () => '' }
    },
    components: {
        Cropper,
        CircleStencil
    },
    data: () => ({
		file: null,
		flagView: false,
		loadingBtn: false,
		loadFile: false,
        image: {
			src: null,
			type: null
		},
    }),
    computed: {
        ...mapGetters({
            getCroppFlag: 'media/getCroppFlag',
			apiUrl: 'apiUrl'
        })
    },
	methods: {
        ...mapMutations({
            setCroppFlag: 'media/setCroppFlag'
        }),
		loadImage(event) {
			this.loadFile = true
			if (event) {
				if (this.image.src) {
					URL.revokeObjectURL(this.image.src)
				}
				const blob = URL.createObjectURL(event);
				const reader = new FileReader();

				reader.onload = (e) => {
					this.image = {
						src: blob,
						type: getMimeType(e.target.result, event.type),
					};
				}

				reader.readAsArrayBuffer(event);
				this.setCroppFlag(true)
			}
		},
		uploadImage() {
			this.loadingBtn = true
			const { canvas } = this.$refs.cropper.getResult();

			if (canvas) {
				const form = new FormData();
				canvas.toBlob(blob => {
					let file = new File([blob], `${this.file.name.split('.')[0]}.png`, { type: "image/png" })

					form.append('File', file);

					this.$http.post(`${this.apiUrl}${this.url}`, form)
					.then(res => {
						this.loadingBtn = false
						this.loadFile = false
						this.setCroppFlag(false)
						this.$emit("submit", res.data)
						this.file = null
                        this.image = { src: null, type: null }
					})
				}, 'image/png');
			}
		},
		cancel() {
			this.loadingBtn = false
			this.loadFile = false
			this.setCroppFlag(false)
			this.file = null
		}
	},
    destroyed() {
		if (this.image.src) {
			URL.revokeObjectURL(this.image.src)
		}
	}
}
</script>

<style lang="scss">
.upload-example {
	margin-top: 20px;
	margin-bottom: 20px;
	user-select: none;
	&__cropper {
		border: solid 1px #eee;
		min-height: 300px;
		max-height: 500px;
		width: 100%;
	}
	&__cropper-wrapper {
		position: relative;
	}
	&__reset-button {
		position: absolute;
		right: 20px;
		bottom: 20px;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 42px;
		width: 42px;
		background: rgba(#3fb37f, 0.7);
		transition: background 0.5s;
		&:hover {
			background: #3fb37f;
		}
	}
	&__buttons-wrapper {
		display: flex;
		justify-content: center;
		margin-top: 17px;
	}
	&__button {
		border: none;
		outline: solid transparent;
		color: white;
		font-size: 16px;
		padding: 10px 20px;
		background: #3fb37f;
		cursor: pointer;
		transition: background 0.5s;
		margin: 0 16px;
		&:hover,
		&:focus {
			background: #38d890;
		}
		input {
			display: none;
		}
	}
	&__file-type {
		position: absolute;
		top: 20px;
		left: 20px;
		background: #0d0d0d;
		border-radius: 5px;
		padding: 0px 10px;
		padding-bottom: 2px;
		font-size: 12px;
		color: white;
	}
}
</style>
